/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCollection = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M1 15h6V2H1zM3 4h2v9H3zm5 4h8V2H8zm2-4h4v2h-4zM1 22h6v-6H1zm2-4h2v2H3zm14 4h6V9h-6zm2-11h2v9h-2zm-2-9v6h6V2zm4 4h-2V4h2zM8 22h8V9H8zm2-11h4v9h-4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCollection as Collection };
